<template>
  <div class="container page pt-3 pb-8 mb-8">
    <slot />
  </div>
</template>

<script>
/**
 * ページのラッパーのコンポーネント
 * 基本的にページはこのコンポーネントでラップする
 * .pageのスタイルはcustom.scssに記載されている
 */
export default {

}
</script>

<style lang="scss" scoped>
</style>